module.exports = __webpack_public_path__ + "img/icon_yecz.3b016618.png";